import { Check, Share2 } from "lucide-react";
import { useEffect, useState } from "react";

import { precisePlateSharePayload, shareContent, type SharePayload } from "../share/share";

export function ShareButton({ payload, label = "Share", className = "button secondary", title }: {
  payload?: SharePayload;
  label?: string;
  className?: string;
  title?: string;
}) {
  const [status, setStatus] = useState<"idle" | "busy" | "shared" | "copied" | "error">("idle");

  useEffect(() => {
    if (status !== "shared" && status !== "copied") return;
    const timeout = window.setTimeout(() => setStatus("idle"), 2400);
    return () => window.clearTimeout(timeout);
  }, [status]);

  async function share() {
    setStatus("busy");
    try {
      const result = await shareContent(payload ?? precisePlateSharePayload());
      setStatus(result === "cancelled" ? "idle" : result);
    } catch {
      setStatus("error");
    }
  }

  const completed = status === "shared" || status === "copied";
  const visibleLabel = status === "busy" ? "Opening..." : status === "copied" ? "Link copied" : status === "shared" ? "Shared" : label;
  return <button type="button" className={className} disabled={status === "busy"} onClick={(event) => { event.preventDefault(); event.stopPropagation(); void share(); }} title={title ?? label} aria-label={title ?? label}>
    {completed ? <Check size={17} /> : <Share2 size={17} />}{visibleLabel}
    <span className="visually-hidden" aria-live="polite">{status === "error" ? "Sharing was not available. Please try again." : completed ? visibleLabel : ""}</span>
  </button>;
}
